import { BasketItemOffer } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedOfferConfirmation } from './checkout-completed-offer-confirmation.interface';

export interface CheckoutCompletedOffer {
  confirmation: CheckoutCompletedOfferConfirmation;
  item: BasketItemOffer;
}
